import React, { Component} from 'react'
import {graphql, Link} from 'gatsby'
import SEO from '../components/SEO'
import Layout from '../components/Layout'
import ProductList from '../components/ProductList'
import Video from '../components/Video'
import PageSection from '../components/PageSection'
import {
	Breadcrumb,
	Container,
	Header,
	Icon,
	Message
} from 'semantic-ui-react'

import * as styles from './styles/template.module.css'
import './styles/blog.css'
import {
	mobileMaxWidth,
	resizeTimer,
	tabletMaxWidth
} from '../globalVar'

const Negosyo = require('../../lib/negosyo')

export default class BlogPage extends Component {
	state = {
		products: [],
		shown:undefined,
		mobile:undefined,
		loadingProducts:true,
		timeOut:undefined,
		errorLoadingProducts:false,
	};

	componentDidMount() {
		this.fetchData();
		this.handler();
		window.addEventListener('resize', this.resizeConsolidator);

		this.addImpressions()

	}

	resizeConsolidator = () => {
		clearTimeout(this.state.timeOut);
		const temp = setTimeout(this.handler, resizeTimer);
		this.setState({
			timeOut:temp
		})
	}

	//adds enhanced e commerce impression for the ingredients list
	addImpressions = () =>{
		const {
			data
		} = this.props
		const { negosyoNow } = data;
		const { viewBlog } = negosyoNow;

		if(viewBlog.ingredientobjlist) {
			if(viewBlog.ingredientobjlist.length > 0 ) {
				let dataLayerList = viewBlog.ingredientobjlist.map((data, index)=>{
					return {
						'name':data.productname,
						'id':data.productsku,
						'price':parseFloat(data.productprice),
						'list':`Ingredient List ${viewBlog.canonical}-${viewBlog.url}`,
						'position':index+1,
						'item_id': data.productsku,
						'item_name': data.productname,
						'currency': "PHP",
						'index': index+1,
						'item_list_id': `Ingredient List ${viewBlog.canonical}-${viewBlog.url}`,
						'item_list_name': `Ingredient List ${viewBlog.canonical}-${viewBlog.url}`,
						'quantity': 1
					}
				})
				let filteredList=dataLayerList.filter(({id})=>{
					return id!==""
				})



				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					'event': 'productList',
					'ecommerce': {
						'impressions': filteredList
					}
				});
			}
		}


	}

	componentWillUnmount() {
		clearTimeout(this.state.timeOut);
		window.removeEventListener('resize', this.resizeConsolidator);
	}

	handler = () => {
		//computer
		if (window.innerWidth > tabletMaxWidth ) {
			this.setState({
				shown: 5,
				mobile:false
			})
		} //tablet
		else if (window.innerWidth > mobileMaxWidth ) {
			this.setState({
				shown : 4,
				mobile:true
			})
		} else {  //mobile
			this.setState({
				shown : 2,
				mobile:true
			})
		}
	}
	fetchData = () => {
		if(this.props.pageContext.fetchData) {
			Negosyo.getProductSearchBlog(this.props.data.negosyoNow.viewBlog.url)
			.then((response) => {
				if(Array.isArray(response) ) {
					this.setState({
						products:response,
						loadingProducts:false
					})
				}else {
					this.setState({
						products:[],
						loadingProducts:false
					})
				}
			}).catch((err)=>{
				if(err.status===404) {
					this.setState({
						products:[],
						loadingProducts:false
					})
				}else {
					this.setState({
						loadingProducts:false,
						errorLoadingProducts:true
					})
				}

			})
		}

	}

	render() {
		const {
			products,
			shown,
			mobile,
			loadingProducts,
			errorLoadingProducts
		} =this.state

		const {
			data, // this prop will be injected by the GraphQL query below.
			location,
			pageContext
		} = this.props
		const { negosyoNow } = data;
		const { viewBlog } = negosyoNow;
		var datePublished = new Date(viewBlog.date);
		const formattedDate = datePublished.toLocaleDateString("en-US", {
				year: 'numeric', month: 'long', day:'2-digit'
			});
		var structuredData = viewBlog.canonical === "recipes"? {
			"@context": "https://schema.org",
			"@type": "Recipe",
			"name": viewBlog.subtitle,
			"datePublished": datePublished.toISOString(),
			"image": [
				viewBlog.squareImageHref
			],
			"author": {
				"@type": "Organization",
				"name": "NegosyoNow"
			},
			"recipeIngredient": viewBlog.ingredientmeta,
			"recipeInstructions": viewBlog.instructionobjlist.map(i => i.content),
			"keywords": viewBlog.recipekeywords,
			"recipeCategory": viewBlog.recipekeywords,
			"description": viewBlog.summary
		}: undefined
		//"datePublished": frontmatter.date,
		//"recipeIngredient": [],
		//"recipeInstructions": []
		return (
			<Layout location={location} backButton={true}>
				<SEO title={viewBlog.name}
					canonicalpath={viewBlog.canonical?
										"/"+viewBlog.canonical+"/"+viewBlog.url
										:
										"/blog/"+viewBlog.url}
					image={viewBlog.squareImageHref} imageWidth={600} imageHeight={400}
					description={viewBlog.summary}
					structuredData={structuredData}
					/>
				<Container className={styles.container}>
					<Breadcrumb className={styles.desktopOnly}>
						<Breadcrumb.Section content="Home" as={Link} to="/"/>
						<Breadcrumb.Divider />
						<Breadcrumb.Section content={pageContext.parenttitle} as={Link} to={"/"+pageContext.parenturl+"/"} />
						<Breadcrumb.Divider />
						{(pageContext.secondaryParentTitle && pageContext.secondaryParentUrl) &&  (
							<React.Fragment>
								<Breadcrumb.Section content={pageContext.secondaryParentTitle} as={Link} to={"/"+pageContext.secondaryParentUrl+"/"} />
								<Breadcrumb.Divider />
							</React.Fragment>
						)}
						<Breadcrumb.Section content={viewBlog.name} />
					</Breadcrumb>
					<Breadcrumb className={styles.mobileOnly}>
						{(pageContext.secondaryParentTitle && pageContext.secondaryParentUrl) ?  (
							<Breadcrumb.Section as={Link} to={"/"+pageContext.secondaryParentUrl+"/"} >
								<Icon name="arrow left" />
								{pageContext.secondaryParentTitle}
							</Breadcrumb.Section>
						):(
							<Breadcrumb.Section as={Link} to={"/"+pageContext.parenturl+"/"} >
								<Icon name="arrow left" />
								{pageContext.parenttitle}
							</Breadcrumb.Section>
						)}
					</Breadcrumb>
					<Header className={`${styles.centerText} ${styles.superHeaderMod}`}>
						<h1>{viewBlog.name}</h1>
						{viewBlog.subtitle && <div className={`${styles.centerText} blog-subtitle`}>{viewBlog.subtitle}</div>}
						<Header.Subheader>
						{ formattedDate }
						</Header.Subheader>
					</Header>
					<div className={styles.item+" blog-content"}>
						{/* 'image-full' sections here will not use ImageHolder since there is no set imageHeightToWidthRatio */}
						<PageSection sectionList={viewBlog.contentobjlist} pageName={viewBlog.name} />
					</div>
					{	viewBlog.ingredientobjlist.length > 0 &&
						<>
							<hr className="blog-section-divider"/>
							<h2>Ingredients</h2>
							<ul className="blog-content blog-ingredient">
							{viewBlog.ingredientobjlist.map((data, index) => {
								if (data.header === 1) {
									return <h3>{data.content}:</h3>
								} 
								return <li key={data.content}>
										<span>{data.volume}</span> {data.content} 
										{data.producturl === ""
											? ""
											:(
												<Link to={`/${data.producturl}/`} onClick={()=>{
													window.dataLayer = window.dataLayer || [];
													window.dataLayer.push({
														'event':'productClick',
														'ecommerce': {
															'click': {
																'actionField': {'list':`Ingredient List ${viewBlog.canonical}-${viewBlog.url}`},
																'products': [{
																	'name':data.productname,
																	'id':data.productsku,
																	'price':parseFloat(data.productprice),
																	'position':index+1,
																	'item_id': data.productsku,
																	'item_name': data.productname,
																	'currency': "PHP",
																	'index': index+1,
																	'item_list_id': `Ingredient List ${viewBlog.canonical}-${viewBlog.url}`,
																	'item_list_name': `Ingredient List ${viewBlog.canonical}-${viewBlog.url}`,
																	'quantity': 1
																}]
															}
														}
													});
												}}>
													&nbsp;&nbsp;<Icon className="blog-carticon" name="cart"/>
												</Link>
											)
										}
									</li>
							})}
							</ul>
						</>
					}
					{	viewBlog.videoobjlist.length > 0 &&
						<>
							<hr className="blog-section-divider"/>
							<h2>Watch Videos</h2>
							{viewBlog.videoobjlist.map((data, index) => {
								return <React.Fragment key={data.externalLink} itemscope="" itemprop="VideoObject" itemtype="https://schema.org/VideoObject">
										<div style={{display:"none"}}>
											<div itemprop="uploadDate">{formattedDate}</div>
											<div itemprop="embedUrl">{data.externalLink}</div>
										</div>
										<h3 itemprop="name">{data.content}</h3>
										<Video src={data.externalLink} title={data.content} size={data.size} />
									</React.Fragment>
							})}
						</>
					}
					{	viewBlog.instructionobjlist.length > 0 &&
						<>
							<hr className="blog-section-divider"/>
							<h2>Directions</h2>
							<ol className="blog-content blog-direction" >
							{viewBlog.instructionobjlist.map((data, index) => {
								return <React.Fragment key={index}>
										<li className="blog-direction-step">
											{data.content}
											{data.details.length > 0 && (
												<ul>
													{data.details.split("\n").map((datasub, indexsub) => {
														if (datasub.length < 1) return <></>
														return <li key={indexsub}>
																{datasub}
															</li>
													})}
												</ul>
											)}
											{data.note !== "" && (
												<div>
													{data.note}
												</div>
											)}
										</li>
									</React.Fragment>
							})}
							</ol>
						</>
					}
					{viewBlog.footer && (
						<p
							className={"blog-content"}
							dangerouslySetInnerHTML={{ __html: viewBlog.footer}}
						/>
					)}
					{errorLoadingProducts===false ? (
						<React.Fragment>
							{ !loadingProducts  && (
								<React.Fragment>
									{products.length>0 && (
										<>
											<hr className="blog-section-divider"/>
											<h2>Shop for Ingredients and Supplies</h2>
											<ProductList
												products={products}
												shown={shown}
												grid={(mobile===false) ? 12:16}
												cameFrom={`${viewBlog.canonical}-${viewBlog.url}`}
												page={1}
												listName={`${viewBlog.canonical}-${viewBlog.url}`}
											/>
										</>
									)}
								</React.Fragment>
							)}
						</React.Fragment>
					):(
						<Message negative className={styles.centerText}>
							<Message.Header>
							Unable to get the products. Please refresh the page
							</Message.Header>
						</Message>
					)}

				</Container>
			</Layout>
		)
	}
}

export const pageQuery = graphql`
  query viewBlog($url: String!) {
    negosyoNow {
      viewBlog(url: $url) {
        date
        url
        name
        subtitle
        footer
        squareImageHref
        canonical
        summary
        recipekeywords
		ingredientobjlist {
			content
			productname
			productprice
			productsku
			producturl
			volume
			header	
		}
        ingredientmeta
		instructionobjlist {
			content
			details
			note
		}
        videoobjlist {
			externalLink
			size
			content
		}
		contentobjlist {
			content
			imgurl
			externalLink
			internalLink
			mobileurl
			title
			type
		}
      }
    }
  }
`